
import { i18nText } from '@/locales';
import moment from 'moment';

export class FinanceOperationForm {
    date: string
    time: string
    payment_article: number | null
    cashbox: number | null
    recipient: string
    sum: number | null
    comment: string

    salon_id?: number | null
    id?: number | null

    recipient_type: number | null
    recipient_data: any
    recipient_name: string

    constructor() {
        this.date = ''
        this.time = ''
        this.payment_article = null
        this.cashbox = null
        this.recipient = ''
        this.sum = null
        this.comment = ''

        this.salon_id = null
        this.id = null

        this.recipient_type = 1
        this.recipient_data = []
        this.recipient_name = i18nText("Контрагент")
    }

    setFormData(data: any) {
        this.date = moment(data.date, 'DD.MM.YYYY') as any
        this.time = data.time
        this.payment_article = data.article_payment_id
        this.cashbox = data.cashbox_id
        this.sum = data.sum
        this.comment = data.comment
        this.salon_id = data.salon_id
        this.id = data.id

        if (data.target) {
            this.recipient = data.target.data || data.target.selected
            this.recipient_type = data.target.id
            this.recipient_data = []
            //this.recipient_data = [data.target.data]
            this.recipient_name = data.target.name
        }
    }
}

export const FormRules = {
    date: [{ required: true, message: i18nText("Укажите дату"), trigger: "change" }],
    time: [{ required: true, message: i18nText("Укажите время"), trigger: "change" }],
    payment_article: [{ required: true, message: i18nText("Укажите статью платежа"), trigger: "change" }],
    recipient: [{ required: true, message: i18nText("Укажите получателя"), trigger: "change" }],
    sum: [{ required: true, message: i18nText("Введите сумму"), trigger: "change" }],
    cashbox: [{ required: true, message: i18nText("Выберите кассу"), trigger: "change" }],
}
